import { render } from "./PrincipalSpouseClientComponent.vue?vue&type=template&id=91e3da26&scoped=true"
import script from "./PrincipalSpouseClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalSpouseClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalSpouseClientComponent.vue?vue&type=style&index=0&id=91e3da26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e3da26"]])

export default __exports__